import { createReduxStore } from '#packages/apilib';

export enum ZoomDirection {
  IN = 'in',
  OUT = 'out',
}

interface State {
  enableCompControls: boolean;
  isTransitioning: boolean;
  enterOrigin: string;
  enableRightClickMenu: boolean;
  transitionPromise: Promise<void>;
  zoomTransitionDirection: ZoomDirection;
  isZoomedByUser: boolean;
  mobileZoomScale: number;
  desktopZoomScale: number;
}

const getInitialState = (): State => ({
  enableCompControls: false,
  isTransitioning: false,
  enterOrigin: null,
  enableRightClickMenu: true,
  transitionPromise: null,
  zoomTransitionDirection: null,
  isZoomedByUser: false,
  mobileZoomScale: 1,
  desktopZoomScale: 1,
});

export const Store = createReduxStore({
  getInitialState,
  selectors: {
    isZoomModeTransitionActive: (state) => state.isTransitioning,
    getZoomModeEnterOrigin: (state) => state.enterOrigin,
    getTransitionPromise: (state) => state.transitionPromise,
    getZoomModeEnabledCompControls: (state) => state.enableCompControls,
    getZoomTransitionDirection: (state) => state.zoomTransitionDirection,
    getZoomModeEnabledRightClickMenu: (state) => state.enableRightClickMenu,
    isZoomedByUser: (state) => state.isZoomedByUser,
    getMobileZoomScale: (state) => state.mobileZoomScale,
    getDesktopZoomScale: (state) => state.desktopZoomScale,
  },
  actions: {
    zoomTransitionStart: (state) => ({ ...state, isTransitioning: true }),
    zoomTransitionEnd: (state) => ({ ...state, isTransitioning: false }),
    setTransitionPromise: (state, transitionPromise) => ({
      ...state,
      transitionPromise,
    }),
    setZoomModeEnabledCompControls: (state, enableCompControls: boolean) => ({
      ...state,
      enableCompControls,
    }),
    setZoomTransitionDirection: (
      state,
      zoomTransitionDirection: ZoomDirection,
    ) => ({
      ...state,
      zoomTransitionDirection,
    }),
    setZoomModeEnabledRightClickMenu: (
      state,
      enableRightClickMenu: boolean,
    ) => ({
      ...state,
      enableRightClickMenu,
    }),
    setZoomModeEnterOrigin: (state, enterOrigin: string) => ({
      ...state,
      enterOrigin,
    }),
    setIsZoomedByUser: (state, isZoomedByUser: boolean) => ({
      ...state,
      isZoomedByUser,
    }),
    setMobileZoomScale: (state, mobileZoomScale: number) => ({
      ...state,
      mobileZoomScale,
    }),
    setDesktopZoomScale: (state, desktopZoomScale: number) => ({
      ...state,
      desktopZoomScale,
    }),
  },
});
